import $axios from "@/plugins/axios-instance";
var fileDownload = require("js-file-download");

export default {
  state: {
    documentsList: []
  },
  getters: {
    getDocumentsList(state) {
      return state.documentsList;
    }
  },
  mutations: {
    addRootCatalog(state, data) {
      state.documentsList.push(data);
    },
    setDocumentsList(state, data) {
      state.documentsList = data;
    }
  },
  actions: {
    documentGet(context) {
      return $axios
        .get("/document")
        .then(response => {
          context.commit("setDocumentsList", response.data);
        })
        .catch(e => {
          throw e.response;
        });
    },

    documentDownload(context, data) {
      return $axios
        .get("/document/" + data.id)
        .then(response => {
          response.data;
        })
        .catch(e => {
          throw e.response;
        });
    },

    documentCreateCatalog(context, data) {
      return $axios
        .post("/document/catalog", data)
        .then(response => {
          return response.data;
        })
        .catch(e => {
          throw e.response;
        });
    },

    documentEditCatalog(context, data) {
      return $axios
        .patch("/document/catalog", data)
        .then(response => {
          return response.data;
        })
        .catch(e => {
          throw e.response;
        });
    },
    documentEditFile(context, data) {
      return $axios
        .patch("/document", data)
        .then(response => {
          return response.data;
        })
        .catch(e => {
          throw e.response;
        });
    },

    documentDeleteCatalog(context, data) {
      return $axios
        .delete("/document/catalog/" + data.id)
        .then(response => {
          return response.data;
        })
        .catch(e => {
          throw e.response;
        });
    },

    documentDeleteFile(context, data) {
      return $axios
        .delete("/document/" + data.id)
        .then(response => {
          return response.data;
        })
        .catch(e => {
          throw e.response;
        });
    },

    documentUploadFile(context, data) {
      return $axios
        .post("/document", data)
        .then(response => {
          return response.data;
        })
        .catch(e => {
          throw e.response;
        });
    },

    documentDeleteImage(context, data) {
      return $axios
        .delete("/document", { data: data })
        .then(response => {
          return response.data;
        })
        .catch(e => {
          throw e.response;
        });
    },

    documentDeleteFiles(context, data) {
      return $axios
        .delete(`/LocalStorage/Delete/${data}`)
        .then(response => {
          return response.data;
        })
        .catch(e => {
          throw e.response;
        });
    },

    documentSort(context, data) {
      let tempStr = data.id ? `?id=${data.id}` : "";
      return $axios
        .post(`/document/sort${tempStr}`, data.data)
        .then(response => {
          return response.data;
        })
        .catch(e => {
          throw e.response;
        });
    }
  }
};
